import Color from 'color';
import { DEFAULT_MAIN_COLOR } from '../../components/mockups/constants';

/**
 * @param color
 * @param rate
 * @returns The given `color` color lightened by `rate`
 */
export const lighten = (color, rate = 0.5) => Color(color).lighten(rate);

/**
 * @param color
 * @param rate
 * @returns The given `color` color darkened by `rate`
 */
export const darken = (color, rate = 0.5) => Color(color).darken(rate);

/**
 * @param color
 * @returns {Number} The HSL lightness level of the given color
 */
export const getLightnessLevel = (color) => Color(color).hsl().lightness();

/**
 * Checks whether the color is white or transparent
 * @param color {String} input hex color (although the library accepts all kinds of color models)
 * @returns {boolean}
 */
export const isTransparent = (color = '') => {
    if (!color) {
        return true;
    }
    const whiteColor = Color(DEFAULT_MAIN_COLOR).hex();
    const transparentColor = Color('transparent').hex();
    const inputColor = Color(color).hex();

    return inputColor === transparentColor || inputColor === whiteColor;
};
